import { ThemeProvider } from '@mui/material/styles';
import { memo } from 'react';
import { selectNavbarTheme, useSettingsSlice } from 'app/store/settingsSlice';
import NavbarStyle1 from './navbar/NavbarStyle';

function NavbarWrapperLayout() {
  const navbarTheme = useSettingsSlice(selectNavbarTheme);

  return (
    <ThemeProvider theme={navbarTheme}>
      <NavbarStyle1 />
    </ThemeProvider>
  );
}

export default memo(NavbarWrapperLayout);
